
import { Navigate, Route, Routes, useLocation, BrowserRouter as Router } from 'react-router-dom';
// import './App.css'
import FiydaaChatBot from '../Pages/FiydaaChatBot';


const MainStack = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<FiydaaChatBot />} />
      </Routes>
    </>
  );
};

export default MainStack;